import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('racaoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/racao`)
		.then(resp => {
			dispatch({
		        type: 'RACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/racao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				
				for (let i = 0; i < registro.itens.length; i++) {
					const formula = registro.itens[i];

					if (formula.ativo) {
						await axios.post(`${consts.API_URL}/racaoFormula`, {
							...formula,
							id_racao: resp.data.id,
							quantidade: FormatUtils.formatarValorBanco(formula.quantidade, 2),
							id_usuario_inclusao: getState().auth.usuario.id,
							id_usuario_alteracao: getState().auth.usuario.id
						}).catch(ex => {
							console.log(ex);
						});
					}					
				}

				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/racao`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {

				for (let i = 0; i < registro.itens.length; i++) {
					const formula = registro.itens[i];

					if (formula.ativo && !formula.id) {
						//Incluir
						await axios.post(`${consts.API_URL}/racaoFormula`, {
							...formula,
							id_racao: registro.id,
							quantidade: FormatUtils.formatarValorBanco(formula.quantidade, 2),
							id_usuario_inclusao: getState().auth.usuario.id,
							id_usuario_alteracao: getState().auth.usuario.id
						}).catch(ex => {
							console.log(ex);
						});
					} else if (formula.ativo && formula.id) {
						//Alterar
						await axios.put(`${consts.API_URL}/racaoFormula`, {
							...formula,
							quantidade: FormatUtils.formatarValorBanco(formula.quantidade, 2),
							id_usuario_alteracao: getState().auth.usuario.id
						}).catch(ex => {
							console.log(ex);
						});
					} else if (!formula.ativo && formula.id) {
						//Excluir
						axios.delete(`${consts.API_URL}/racaoFormula?id=${formula.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
						.catch(e => {
							setErroAPI(e);
						});
					}
				}
				
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/racao?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaCnhCategoria() {
    const request = axios.get(`${consts.API_URL}/cnhCategoria/listarSelect`);
    return {
        type: 'RACAO_CNH_CATEGORIA_LISTADO',
        payload: request
    };
}